"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = exports.ROLE = void 0;
var Source;
(function (Source) {
    Source["SELF"] = "SELF";
    Source["INVITATION"] = "INVITATION";
})(Source || (Source = {}));
var ROLE;
(function (ROLE) {
    ROLE["ADMIN"] = "ADMIN";
    ROLE["NON_ADMIN"] = "NON_ADMIN";
})(ROLE = exports.ROLE || (exports.ROLE = {}));
var Entity;
(function (Entity) {
    Entity["ALL"] = "ALL";
    Entity["INBOUND"] = "INBOUND";
    Entity["INVENTORY"] = "INVENTORY";
    Entity["ORDER"] = "ORDER";
    Entity["BILLING"] = "BILLING";
    Entity["CHANNEL"] = "CHANNEL";
    Entity["REPORTS"] = "REPORTS";
})(Entity = exports.Entity || (exports.Entity = {}));
//# sourceMappingURL=User.js.map